export const homeObjOne = {
  id: 'discover',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Inspiring Success',
  topLineDark: false,
  headline: 'Top-Notch Business Communication Solutions',
  description: 'This paragraph, you can write your own content here, and fill in the blanks, and fill in the blanks, and fill in the blanks.',
  buttonLabel: 'Get Started',
  imgStart: false,
  img: require('../../images/svg/svg12.svg'),
  alt: 'alt',
  dark: true,
  primary: true,
  darkText: false,
}

export const homeObjTwo = {
  id: 'signin',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Book A Time',
  topLineDark: true,
  headline: 'Promote your brand, spread the word',
  description: 'This paragraph, you can write your own content here, and fill in the blanks, and fill in the blanks, and fill in the blanks.',
  buttonLabel: 'Learn More',
  imgStart: true,
  img: require('../../images/svg/svg2.svg'),
  alt: 'alt',
  dark: false,
  primary: false,
  darkText: true,
}

export const homeObjThree = {
  id: 'games',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Join Our Team',
  topLineDark: true,
  headline: 'Dependable, Simple & Profitable Financial Solutions',
  description: 'This paragraph, you can write your own content here, and fill in the blanks, and fill in the blanks, and fill in the blanks.',
  buttonLabel: 'Join Now',
  imgStart: false,
  img: require('../../images/svg/svg14.svg'),
  alt: 'alt',
  dark: false,
  primary: false,
  darkText: true,
}